// extracted by mini-css-extract-plugin
export default {"highlight":"rRig5vv6"};